import AdminConfig from './admin';

import ClientView from './client';


export default {
  name : 'form',

  type : 'module',
  
  label: 'Formulaire',

  components: {

    admin: AdminConfig,

    client: ClientView

  },

  settings: {
    icon: 'mdi-form-textarea',
  }
}